<template>
    <div class="tabs_content" id="tab-2">
      <section v-if="messageEntity.processed_at == null">
        <div v-translate>Marketingové oznámení ještě nebylo zpracováno.</div>
      </section>
      <section v-else>
        <div class="filter search_only">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search" />
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="table_overflow">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
            <thead>
            <tr>
              <th class="no_padding drag_drop"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <RecipientsRow
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                :idAdvertisingBanner="messageEntity.id"
                @input="select"
            ></RecipientsRow>
            </tbody>
          </table>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="filteredSelectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              :disable-select-all="true"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </section>
    </div>
  </template>

<script>
import listActions from "@/components/mixins/list-actions"
import RecipientsRow from "./RecipientsRow.vue";
export default {
  name: "AdvertisingBannerRecipients",
  components: {RecipientsRow},
  mixins: [listActions],
  props: {
    isEditable: Boolean,
    isUpdate: Boolean,
    isProcessed: Boolean,
    messageEntity: Object,
  },
  data(){
    return {
      entitiesKey: "recipients",
      formFields: {
        limit: 50,
        offset: 0,
        search: '',
        sort: {
          column: 'subscriberName',
          direction: 'asc'
        }
      },
    }
  },
  created(AdvertisingBannerRecipientService) {
    this.entityService = AdvertisingBannerRecipientService
    this.createdInit()
  },
  computed: {
    sortingTableTitles() {
      return [
        {id: 1, name: this.$gettext('Odběratel'), column: 'subscriberName'},
        {id: 2, name: this.$gettext('Přečteno na zařízení/celkem'), column: 'recipients_devices_read'},
        {id: 4, name: this.$gettext('Označeno za smazané'), column: 'timestamp_deleted'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles, true)
      headers.recipients_devices_read.callback = (entity) => {return entity.recipients_devices_read +' / '+ entity.recipients_devices_read};
      headers.timestamp_deleted.callback = (entity) => {return entity.timestamp_deleted ? this.$_datetime_format(entity.timestamp_deleted) : ''};

      return headers;
    },
  },
  methods: {
    _processFormFields(formFields) {
      formFields["id"] = this.$route.params.id;
      return formFields
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Detail/Recipients.vue